export default {
  base_url: 'https://api.sb.ronad.ir/v1',
  warehouses: [],
  destinationId: 19,
  centerId: 126
};
